import { courseMetadataApi } from '../api';
import type { SearchCourseDiscoveryResults } from '../types';

export async function orgSearch(
  languageCode: string,
  callback: (results: SearchCourseDiscoveryResults) => void,
): Promise<void> {
  await courseMetadataApi.getCourseSearch(languageCode, callback);
}

export async function getCourseCatalogue(languageCode: string): Promise<SearchCourseDiscoveryResults> {
  return new Promise<SearchCourseDiscoveryResults>((resolve, reject) => {
    orgSearch(languageCode, (results: SearchCourseDiscoveryResults) => resolve(results))
      .catch(reject);
  });
}
